<div class="wrapper">
    <img [src]="imageUrl" />
    <p style="padding-right: 5px;">{{ content }}</p>
</div>